<template>
    <modal
        :id="id"
        size="md"
        :action-buttons="true"
        :save-action="save"
        @shown="shown"
        @hidden="hidden"
        :delete-action="task._id ? deleteAction : null"
        :title="$t('Tasks')"
    >
        <div class="row align-items-center">
            <div class="col-12">
                <b-form-group :label="$t('tasks.task-type')">
                    <b-form-radio-group
                        v-model="task.type"
                        name="payout-options"
                    >
                        <b-form-radio :value="'TREATMENT_REMINDER'">{{ $t('tasks.treatment-reminder') }}
                        </b-form-radio>
                        <b-form-radio :value="'USER_TASK'">{{ $t('tasks.user-reminder') }}
                        </b-form-radio>
                    </b-form-radio-group
                    >
                </b-form-group>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-6">
                <div class="form-group">
                    <label>{{ $t('Start date') }}</label>
                    <date-picker v-model="task.startDate"></date-picker>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label>{{ $t('Due date') }}</label>
                    <date-picker v-model="task.dueDate"></date-picker>
                </div>
            </div>
        </div>
        <div class="row align-items-center" v-for="(upcoming, index) in task.upcoming" :key="index">
            <div class="col">
                <div class="form-group">
                    <label v-if="index === 0">{{$t('Select team member')}}</label>
                    <team-select v-model="upcoming.userId" :idOnly="true"></team-select>
                </div>
            </div>
            <div class="col" v-if="task.type === 'TREATMENT_REMINDER'">
                <div class="form-group">
                    <label v-if="index === 0">{{ $t('Select service') }}</label>
                    <services-select v-model="upcoming.treatment"></services-select>
                </div>
            </div>
            <div class="col-auto" v-if="task.type === 'TREATMENT_REMINDER'">
                <label v-if="index === 0"></label>
                <div class="form-group">
                    <confirmable-button
                        style="display:inline;"
                        buttonClass="btn btn-white d-lg-inline-block"
                        v-if="index !== task.upcoming.length - 1"
                        @confirm="removeService(index)"
                    >
                        <i class="fe fe-trash-2"></i>
                    </confirmable-button>
                    <button
                        class="btn btn-white"
                        v-if="index === task.upcoming.length-1"
                        @click="addService(index)"
                    >
                        <i class="fe fe-plus"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-12">
                <div class="form-group">
                    <label v-if="task.type === 'TREATMENT_REMINDER'">{{ $t('Notes') }}</label>
                    <label v-else>{{ $t('tasks.task-description') }}</label>
                    <b-form-textarea v-model.trim="task.note"
                                     :placeholder="task.type === 'TREATMENT_REMINDER' ? $t('Do not call after 8 p.m.') : $t('tasks.desc-placeholder')"></b-form-textarea>
                </div>
            </div>
            <template v-if="task.type === 'TREATMENT_REMINDER'">
                <div v-if="task.customerId" class="col-12 mt-5">
                    <div class="card">
                        <div class="card-body p-2">
                            <div class="row align-items-center">
                                <div class="col-auto text-center">
                                    <avatar :src="customer.avatar.preview" size="avatar-sm" type="circle"></avatar>
                                </div>
                                <div class="col ml-n3">
                                    <h4 class="card-title mb-1">{{ customer.first_name }} {{ customer.last_name }}</h4>
                                    <p class="card-text small text-muted">
                                        {{ customer.phone }}
                                        {{ customer.email }}
                                    </p>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-white btn-sm" @click="task.customerId=null">
                                        <i class="fe fe-x"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="col-12 mt-5">
                    <find-customer v-model="task.customerId"></find-customer>
                </div>
            </template>
        </div>
    </modal>
</template>

<script>
import Avatar from "@/components/Avatar";
import {mapActions, mapGetters} from "vuex";
import {modalMixins} from '@/mixins/modal.js'
import Modal from "@/components/Modal";
import DatePicker from "@/components/DatePicker";
import TeamSelect from "@/components/TeamSelect";
import FindCustomer from "@/components/FindCustomer";
import ServicesSelect from "@/components/ServicesSelect";
import ConfirmableButton from '@/components/ConfirmableButton';

export default {
    name: "TaskModal",
    mixins: [modalMixins],
    components: {
        ServicesSelect,
        Modal,
        Avatar,
        DatePicker,
        TeamSelect,
        FindCustomer,
        ConfirmableButton
    },
    props: {
        id: String
    },
    data() {
        return {
            task: {
                dueDate: this.$moment().add(1, 'day').format('Y-MM-D'),
                type: 'TREATMENT_REMINDER'
            }
        };
    },
    methods: {
        ...mapActions('tasks', { createTask: 'create', editTask: 'patch', deleteTask: 'remove' }),

        addService() {
            let initial = {};
            const length = this.task.upcoming.length;
            if (length >= 1) {
                initial.userId = this.task.upcoming[length - 1].userId
            }
            this.task.upcoming.push(initial);
        },

        removeService(index) {
            this.task.upcoming.splice(index, 1)
        },

        save() {
            this.task.upcoming = this.task.upcoming.map(el => {
                return { userId: el.userId, treatmentId: el.treatment ? el.treatment._id : null }
            });
            if (this.task._id) {
                this.editTask([this.task._id, this.task]).then(() => {
                    this.$root.$emit("bv::hide::modal", this.id);
                    this.$toasted.global.success({
                        message: this.$t("Changes saved")
                    });
                }).catch(error => console.log(error));
            } else {

                this.createTask(this.task).then(() => {
                    this.$root.$emit("bv::hide::modal", this.id);
                    this.$toasted.global.success({
                        message: this.$t("New task created")
                    });
                });
            }
        },


        deleteAction() {
            this.deleteTask(this.task._id);
        },

        shown() {
            const { Task } = this.$FeathersVuex;
            let data = Task.getFromStore('temp');
            if (data) {
                delete data._id;
                this.task = { ...this.$deepCopy(data.model), type: 'TREATMENT_REMINDER' };

                new Task({
                    _id: 'temp',
                    model: {}
                });
            } else {
                // this.task = Object.assign(data.model, this.task);
            }

            if (!this.task.upcoming) {
                this.$set(this.task, 'upcoming', [{}])
            }
        },

        hidden() {
            this.task = { type: 'TREATMENT_REMINDER' };
        },
    },
    computed: {
        ...mapGetters('customers', {
            getCustomerFromStore: 'get'
        }),

        customer() {
            return this.getCustomerFromStore(this.task.customerId)
        }
    }
};
</script>

<style scoped>
</style>
